import { render } from "./WorkflowfolgenDetailsBeschreibung.pug?vue&type=template&id=5f35a61d&lang=pug"
import script from "./WorkflowfolgenDetailsBeschreibung.js?vue&type=script&lang=js"
export * from "./WorkflowfolgenDetailsBeschreibung.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__